import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ClientService } from '../../../services/client.service';
import { ClinicService } from '../../../services/clinic.service';
import { CatalogService } from '../../../services/catalog.service';
import { SharedService } from '../../../services/shared.service';
import { ClientCodeModel } from '../../../models/client-code.model';
import { ZipModel } from '../../../models/zip.model';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-client-info',
  templateUrl: './client-info.component.html',
})
export class ClientInfoComponent implements OnInit {

  private _client_no: number;
  buscador_activo = false;
  lst_codes: ClientCodeModel[] = []
  suggestedWordsArray: ClientCodeModel[] = [];
  suggestedzWordsArray: ZipModel[] = [];
  code: ClientCodeModel = new ClientCodeModel('', '');
  zip: ZipModel = new ZipModel('', '', '', '', 0);
  view_cc = false;
  view_ld = false;
  clientImage:any;

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public clientService: ClientService,
    public catalogService: CatalogService,
    public clinicService: ClinicService,
    public petService: PetService,
    public sharedService: SharedService,
    public router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.sharedService.newClientObservable.subscribe(() => {
      if (this.clientService.client.image_id == 0) {
        this.getTempClientImage();
      }
      else{
        this.getPetImage();
      } 
    })

    if (this.clientService.client.client_no != 0) {
      this.getPetImage()
    }
    else{
      this.clientImage = null;
    }
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    }) 

    if (this.petService.tempfiles.length > 0) {
      this.setupImage().then((imageId) => {
        this.clinicService.person.image_id = Number(imageId);
        this.setupClient();
      }); 
    } else {
      this.setupClient(); 
    } 
      
  }

  setupImage(): Promise<number> {
    return this.petService.setupImages(this.petService.tempfiles[0]).then((res) => {
      return Number(res);
    });
  }

  setupClient() {
    this.clientService.setupClient().then((client_no: number) => { 
      $('#modalNewClient').modal('hide');
      Swal.fire({
        title: 'Your information has been saved.',
        didOpen: () => {
          //client/client-form/1
          //this.router.navigate([`/pages/client/client-form/${client_no}`]);
          this.clientService.getClientById(client_no).then(() => { }); 
        },
      })
    });
  }

  translate_codes() {
    this.lst_codes = []
    if (this.clientService.client.client_code) {
      let items = this.clientService.client.client_code.split('');
      if (items) {
        items.forEach(element => {
          if (this.catalogService.client_code.some(t => t.code === element)) {
            this.lst_codes.push(this.catalogService.client_code.find(t => t.code === element))
          }
        });
      }
    }
  }

  codes() {
    this.translate_codes();
    $("#modalNewClientInfoCodes").modal('toggle')
  }

  close_codes() {
    $("#modalNewClientInfoCodes").modal('toggle')
  }

  search(event: any) {
    setTimeout(() => {
      this.code.code = event.target.value;

      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.suggestedWordsArray = [];
        this.buscador_activo = false;
      }

      if (this.code.code.length > 0) {
        this.suggestedWordsArray = [];
        this.suggestedWordsArray.push(...this.catalogService.filterArray<ClientCodeModel>(this.catalogService.client_code, this.code.code.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), "code"));
        this.buscador_activo = this.suggestedWordsArray.length > 0;

      } else {
        this.suggestedWordsArray = [];
        this.buscador_activo = this.suggestedWordsArray.length > 0;
      }
    }, 100);
  }

  searchz(event: any) {
    setTimeout(() => {
      this.code.code = event.target.value;

      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.suggestedzWordsArray = [];
        this.buscador_activo = false;
      }

      if (this.code.code.length > 0) {
        this.suggestedzWordsArray = [];
        this.suggestedzWordsArray.push(...this.catalogService.filterArray<ZipModel>(this.catalogService.zip, this.code.code.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), "zip_code"));
        this.buscador_activo = this.suggestedzWordsArray.length > 0;

      } else {
        this.suggestedzWordsArray = [];
        this.buscador_activo = this.suggestedzWordsArray.length > 0;
      }
    }, 100);
  }

  async select(item: ClientCodeModel) {
    this.code = new ClientCodeModel(item.code, item.name);
    this.suggestedWordsArray = [];
    this.buscador_activo = this.suggestedWordsArray.length > 0;
  }

  async selectz(item: ZipModel) {
    this.clientService.client.city = item.city;
    this.clientService.client.state = item.state;
    this.clientService.client.zip = item.zip_code;
    this.clientService.client.county = item.county;
    this.suggestedzWordsArray = [];
    this.buscador_activo = this.suggestedzWordsArray.length > 0;
  }

  add() {
    if (this.clientService.client.client_code.includes(this.code.code)) {
      Swal.fire({
        title: 'Duplicated code',
        didOpen: () => {
        },
      })
      this.code = new ClientCodeModel('', '');
      return;
    }
    this.clientService.client.client_code += `${this.code.code}`;
    this.translate_codes();
    this.code = new ClientCodeModel('', '');
  }

  delete(item: ClientCodeModel) {
    this.clientService.client.client_code = this.clientService.client.client_code.replace(item.code, '');
    this.translate_codes();
  }

  view(field: string) {
    switch (field) {
      case 'credit_card':
        $('#modalNewClientInfoCreditCard').modal('toggle');
        this.view_cc = !this.view_cc;
        break;
      case 'driver_license':
        $('#modalNewClientInfoDriveLicense').modal('toggle');
        this.view_ld = !this.view_ld;
        break;
    }
  }

  source() {
    $("#modalNewClientInfoSource").modal('toggle');
  }

  close_source() {
    $("#modalNewClientInfoSource").modal('toggle');
  }

  //#startregion camera
  openCameraModal() {
    $('#modalCamera').modal('toggle');
    this.sharedService.triggerCameraInit('newclient', this.clientService.client.client_no);
  }

  onImageError(event: Event) { 
    const element = event.target as HTMLImageElement;
    element.src = 'assets/images/landscape-placeholder.svg';
  }

  getTempClientImage() { 
    this.clientImage = `data:image/png;base64,${this.petService.tempfiles[0].value}`;
  }

  getPetImage() {
    const pictureNumber = Number(this.clientService.client.image_id);
    if (!isNaN(pictureNumber)) { 
      this.petService.getImage(pictureNumber).then((res) => {
        this.clientImage = res; 
      })
    }
    else{
      this.clientImage = null;
    }
  }
  //#endregion
}
